// extracted by mini-css-extract-plugin
module.exports = {"customBtn":"ButtonIcon_customBtn__3lYDW","icon":"ButtonIcon_icon__3MyT1"};